import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);
//解决往同一地址跳转时会报错
const originalPush = Router.prototype.push
const originalReplace = Router.prototype.replace
Router.prototype.push = function push (location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch(err => err)
}
Router.prototype.replace = function push (location, onResolve, onReject) {
    if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
    return originalReplace.call(this, location).catch(err => err)
}

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      component: () => import("@/components/pc/home/home"),
      name: "indexs",
      redirect: "/indexs",
      children: [
        {
          path: "/indexs",
          component: () => import("@/components/pc/index/index"),
          name: "indexs",
          meta: {
            title: "中国建筑出版在线-首页"
          }
        },{
          path: "/architecturepublishing",
          component: () => import("@/components/pc/architecturepublishing/architecturepublishing"),
          name: "architecturepublishing",
          meta: {
            title: "中国建筑出版在线-建筑图书"
          }
        },{
          path: "/digitalTextbooks",
          component: () => import("@/components/pc/digitalTextbooks/digitalTextbooks"),
          name: "digitalTextbooks",
          meta: {
            title: "中国建筑出版在线-数字教材"
          }
        },{
          path: "/newBookList",
          component: () => import("@/components/pc/architecturepublishing/components/newBookList"),
          name: "newBookList",
          meta: {
            title: "中国建筑出版在线-新书预售"
          }
        },
        {
          path: '/subjectLibrary',
          component: () => import("@/components/pc/subjectLibrary/subjectLibrary"),
          name: 'subjectLibrary',
          meta: {
            title: "中国建筑出版在线-专题库"
          }
        },
        {
          path: '/subjectDetail',
          component: () => import("@/components/pc/subjectLibrary/subjectDetail/subjectDetail"),
          name: 'subjectDetail',
          meta: {
            title: "中国建筑出版在线-专题库"
          }
        },
        {
            path: '/journalsDetail',
            component: () => import("@/components/pc/subjectLibrary/subjectDetail/journalsDetail"),
            name: 'journalsDetail',
            meta: {
              title: "中国建筑出版在线-专题库"
            }
          },
        {
          path: '/news',
          component: () => import("@/components/pc/newsInformation/newsInformation"),
          name: 'newsInformation',
          meta: {
            title: "中国建筑出版在线-活动动态"
          }
        },
        {
          path: '/newsdetails',
          component: () => import("@/components/pc/newsContent/newsContent"),
          name: 'news',
          meta: {
            title: "中国建筑出版在线-活动内容"
          }
        },
        {
          path: '/authorDetail',
          component: () => import("@/components/pc/authorList/authorDetail/authorDetail"),
          name: 'authorDetail',
          meta: {
            title: "中国建筑出版在线-作者详情"
          }
        },
        {
            path: '/authorList',
            component: () => import("@/components/pc/authorList/authorList"),
            name: 'authorList',
            meta: {
              title: "中国建筑出版在线-作者列表"
            }
          },
        {
          path: '/commodity-list',
          component: () => import("@/components/pc/searchPage/searchPage"),
          name: 'commodity-list',
          meta: {
            title: "中国建筑出版在线-搜索结果页"
          }
        },
        {
          path: '/commodity-details',
          component: () => import("@/components/pc/productDetails/productDetails"),
          name: 'commodity-details',
          meta: {
            title: "中国建筑出版在线-商品详情"
          }
        },
        {
          path: '/packageDetails',
          component: () => import("@/components/pc/packageDetails/packageDetails"),
          name: 'packageDetails',
          mata: {
            title: "中国建筑出版在线-增值包详情"
          }
        },
        {
            path: '/courseDetail',
            component: () => import("@/components/pc/packageDetails/courseDetail"),
            name: 'courseDetail',
            mata: {
              title: "中国建筑出版在线-公开课详情"
            }
          },
          // {
          //   path: '/player',
          //   component: () => import("@/components/pc/player/player"),
          //   name: 'player',
          //   meta: {
          //     title: "中国建筑出版在线-直播课"
          //   }
          // },
          {
            path: '/player',
            component: () => import("@/components/pc/player/playBack"),
            name: 'player',
            meta: {
              title: "中国建筑出版在线-直播课"
            }
          },
        {
          path: '/seniorSearch',
          component: () => import("@/components/pc/searchPage/components/seniorSearch"),
          name: 'seniorSearch',
          meta: {
            title: "中国建筑出版在线-高级搜索"
          }
        },
        {
          path: "/helpCenter",
          component: () => import("@/components/pc/helpCenter/helpCenter"),
          name: "helpCenter",
          meta: { title: "帮助中心",
          //  requireAuth: true
           }
        },
        {
          path: "/aboutUs",
          component: () => import("@/components/pc/aboutUs/aboutUs"),
          name: "aboutUs",
          meta: { title: "关于我们",
          //  requireAuth: true 
          }
        },
        {
          path: "/contactUs",
          component: () => import("@/components/pc/aboutUs/contactUs"),
          name: "contactUs",
          meta: { title: "联系我们",
          //  requireAuth: true 
          }
        },
        {
          path: "/permitFile",
          component: () => import("@/components/pc/head_ bottom/permitFile"),
          name: "permitFile",
          meta: { title: "出版物经营许可" }
        },
        {
          path: "/jzFile",
          component: () => import("@/components/pc/head_ bottom/jzFile"),
          name: "jzFile",
          meta: { title: "出版物经营许可" }
        },
        //首页banner跳转路由
        {
          path: "/registrationstructure",
          component: () => import("@/components/pc/bannerHerf/registrationstructure/registrationstructure"),
          name: "registrationstructure",
          meta: { title: "注册结构工程师备考应该看啥书" }
        },
        {
          path: "/active-jlgcsks",
          component: () => import("@/components/pc/bannerHerf/active-jlgcsks/active-jlgcsks"),
          name: "active-jlgcsks",
          meta: {
            title: "商品详情",
          }
        },
        {
          path: "/yjActiveNews",
          component: () => import("@/components/pc/bannerHerf/activeNews_2023/yjActiveNews"),
          name: "yjActiveNews",
          meta: { title: "活动详情" }
        },
        {
          path: "/activeNews",
          component: () => import("@/components/pc/bannerHerf/activeNews_2023/activeNews"),
          name: "activeNews",
          meta: { title: "活动详情" }
        },
        {
          path: "/activeNews_2023",
          component: () => import("@/components/pc/bannerHerf/activeNews_2023/activeNews_2023"),
          name: "activeNews_2023",
          meta: { title: "活动详情" }
        },
        {
          path: "/active_news",
          component: () => import("@/components/pc/bannerHerf/active_news/active_news"),
          name: "active_news",
          meta: { title: "活动详情" }
        },
        {
          path: "/active_news_yj",
          component: () => import("@/components/pc/bannerHerf/active_news/active_news_yj"),
          name: "active_news_yj",
          meta: { title: "活动详情" }
        },
        {
            path: "/activity_topic",
            component: () => import("@/components/pc/activityTopic/activityTopic"),
            name: "activity_topic",
            meta: { title: "活动促销" }
          },
      ]
    },
    {
      path: "/mHome",
      component: () => import('@/components/h5/mHome/mHome'),
      name: "mHome",
      meta: {
        title: "首页",
      }
    },
    {
      path: "/msearch",
      component: () => import('@/components/h5/mSearch/mSearch'),
      name: "msearch",
      meta: {
        title: "首页",
      }
    },
    {
      path: '/announcement',
      component: () => import("@/components/h5/announcement/announcement"),
      name: 'announcement',
      meta: {
        title: "公告"
      }
    },
    {
      path: '/announcementInfo',
      component: () => import("@/components/h5/announcement/components/announcementInfo"),
      name: 'announcementInfo',
      meta: {
        title: "公告详情"
      }
    },
    {
      path: "/mgoodsInfo",
      component: () => import('@/components/h5/mgoods/mgoodsInfo/mgoodsInfo'),
      name: "mgoodsInfo",
      meta: {
        title: "商品详情",
      }
    },
    {
      path: "/mProducts",
      component: () => import('@/components/h5/mProducts/mProducts'),
      name: "mProducts",
      meta: {
        title: "产品详情",
      }
    },
    {
      path: "/mExchange",
      component: () => import('@/components/h5/mgoods/mExchange/mExchange'),
      name: "mExchange",
      meta: {
        title: "商品-兑换",
      }
    },
    {
      path: "/mxgtj",
      component: () => import('@/components/h5/mgoods/mxgtj/mxgtj'),
      name: "mxgtj",
      meta: {
        title: "相关推荐"
      }
    },
    {
      path: "/mSecondPage",
      component: () => import('@/components/h5/mSecondPage/mSecondPage'),
      name: "mSecondPage",
      meta: {
        title: "数字资源",
      }
    },
    {
      path: "/mFreeResource",
      component: () => import('@/components/h5/mFreeResource/mFreeResource'),
      name: "mFreeResource",
      meta: {
        title: "数字资源",
      }
    },
    {
      path: "/architecturalbooksh5",
      component: () => import('@/components/h5/mArchitecturepublishing/mArchitecturepublishing'),
      name: "architecturalbooksh5",
      meta: {
        title: "建筑图书",
      }
    },
    {
      path: "/mStandard",
      component: () => import('@/components/h5/mStandard/mStandard'),
      name: "mStandard",
      meta: {
        title: "标准规范",
      }
    },
    {
      path: "/mDigitalTextbooks",
      component: () => import('@/components/h5/mDigitalTextbooks/mDigitalTextbooks'),
      name: "mDigitalTextbooks",
      meta: {
        title: "数字教材",
      }
    },
    {
      path: "/mStandardType",
      component: () => import('@/components/h5/mStandard/components/mStandardType'),
      name: "mStandardType",
      meta: {
        title: "标准分类",
      }
    },
    {
      path: "/mStandardSearch",
      component: () => import('@/components/h5/mStandard/components/mStandardSearch'),
      name: "mStandardSearch",
      meta: {
        title: "标准搜索",
      }
    },
    {
      path: "/filterProducts",
      component: () => import('@/components/h5/filterProducts/filterProducts'),
      name: "filterProducts",
      meta: {
        title: "标准规范",
      }
    },
    {
      path: "/presaleh5",
      component: () => import('@/components/h5/mArchitecturepublishing/components/mBookPresaleList'),
      name: "presaleh5",
      meta: {
        title: "新书预售",
      }
    },
    {
      path: "/mList",
      component: () => import('@/components/h5/mList/mList'),
      name: "mList",
      meta: {
        title: "榜单",
      }
    },
    {
      path: "/mExam",
      component: () => import('@/components/h5/mExam/mExam'),
      name: "mExam",
      meta: {
        title: "执业考试",
      }
    },{
      path: "/mCourseSystem",
      component: () => import('@/components/h5/mExam/components/mCourseSystem/mCourseSystem'),
      name: "mCourseSystem",
      meta: {
        title: "课程体系",
      }
    },{
      path: "/mQuestionBank",
      component: () => import('@/components/h5/mExam/components/mQuestionBank/mQuestionBank'),
      name: "mQuestionBank",
      meta: {
        title: "在线题库",
      }
    },{
      path: "/mExamBook",
      component: () => import('@/components/h5/mExam/components/mExamBook/mExamBook'),
      name: "mExamBook",
      meta: {
        title: "考试用书",
      }
    },
    {
      path: "/mFreeOpenClass",
      component: () => import('@/components/h5/mExam/components/mFreeOpenClass/mFreeOpenClass'),
      name: "mFreeOpenClass",
      meta: {
        title: "免费公开课报名",
      }
    },
    {
      path: "/mOpenClassList",
      component: () => import('@/components/h5/mExam/components/mOpenClassList/mOpenClassList'),
      name: "mOpenClassList",
      meta: {
        title: "免费公开课",
      }
    },
    {
      path: "/mAuthorList",
      component: () => import('@/components/h5/mAuthor/mAuthorList'),
      name: "mAuthorList",
      meta: {
        title: "资深专家",
      }
    },
    {
      path: "/mAuthorDetails",
      component: () => import('@/components/h5/mAuthor/mAuthorDetails'),
      name: "mAuthorDetails",
      meta: {
        title: "作者详情",
      }
    },
    {
      path: "/goodsresult",
      component: () => import('@/components/h5/mSearch/components/mSearchResult/mSearchResult'),
      name: "goodsresult",
      meta: {
        title: "搜索-结果",
      }
    },
    {
        path: "/activityTopicH5",
        component: () => import('@/components/h5/activityTopicH5/activityTopicH5'),
        name: "activityTopicH5",
        meta: {
          title: "活动详情",
        }
    },
    {
        path: "/studySearch",
        component: () => import('@/components/h5/mStudy/components/studySearch'),
        name: "studySearch",
        meta: {
          title: "搜索",
        }
    },
    {
        path: "/redeemDetail",
        component: () => import('@/components/h5/mStudy/components/redeemDetail'),
        name: "redeemDetail",
        meta: {
          title: "增值包列表详情",
        }
    },
    {
      path: "/productDetail",
      component: () => import('@/components/h5/mStudy/components/productDetail'),
      name: "productDetail",
      meta: {
        title: "商品目录详情",
      }
    },
    {
      path: "/categoryh5",
      component: () => import('@/components/h5/mCategory/mCategory'),
      name: "categoryh5",
      meta: {
        title: "分类",
      }
    },
    {
      path: "/studyh5",
      component: () => import('@/components/h5/mStudy/mStudy'),
      name: "mStudy",
      meta: {
        title: "学习",
      }
    },
    {
        path: "/carh5",
        component: () => import('@/components/h5/mCar/mCar'),
        name: "mCar",
        meta: {
          title: "购物车",
        }
      },
      {
        path: "/settlement",
        component: () => import('@/components/h5/mCar/components/settlement'),
        name: "settlement",
        meta: {
          title: "订单确认",
        }
      },//placeOrder
      {
        path: "/orderPay",
        component: () => import('@/components/h5/mCar/components/orderPay'),
        name: "orderPay",
        meta: {
          title: "订单支付",
        }
      },
      {
        path: "/alipay",
        component: () => import('@/components/h5/mCar/components/alipay'),
        name: "alipay",
        meta: {
          title: "支付宝支付",
        }
      },
      {
        path: "/paySuccess",
        component: () => import('@/components/h5/mCar/components/paySuccess'),
        name: "paySuccess",
        meta: {
          title: "支付成功",
        }
      },
    {
      path: "/mSubject",
      component: () => import('@/components/h5/mSubject/mSubject'),
      name: "mSubject",
      meta: {
        title: "专题",
      }
    },
    {
      path: "/mPeriodical",
      component: () => import('@/components/h5/mPeriodical/mPeriodical'),
      name: "mPeriodical",
      meta: {
        title: "专题期刊",
      }
    },
    {
      path: "/mSubjectDetails",
      component: () => import('@/components/h5/mSubject/mSubjectDetails/mSubjectDetails'),
      name: "mSubjectDetails",
      meta: {
        title: "专题详情",
      }
    },
    {
      path: "/mPlayer",
      component: () => import('@/components/h5/mPlayer/mPlayer'),
      name: "mPlayer",
      meta: {
        title: "播放页",
      }
    },
    {
      path: "/mBookList",
      component: () => import('@/components/h5/mBookList/mBookList'),
      name: "mBookList",
      meta: {
        title: "书单-h5",
      }
    },
    {
      path: "/mSampleApplication",
      component: () => import('@/components/h5/mSampleApplication/mSampleApplication'),
      name: "mSampleApplication",
      meta: {
        title: "样书申请表-h5",
      }
    },
    {
      path: "/bookstoreh5",
      component: () => import('@/components/h5/bookstore/bookstore'),
      name: "bookstore",
      meta: {
        title: "建筑书店-h5",
      }
    },
    {
      path: "/primary_Registeredh5",
      component: () => import('@/components/h5/mHome/components/mBannerLink/primary_Registered/primary_Registered'),
      name: "primary_Registered",
      meta: {
        title: "Banner一建-h5",
      }
    },
    {
      path: "/associate_Constructorh5",
      component: () => import('@/components/h5/mHome/components/mBannerLink/associate_Constructor/associate_Constructor'),
      name: "associate_Constructor",
      meta: {
        title: "Banner二建-h5",
      }
    },
    {
      path: "/m_active_news",
      component: () => import('@/components/h5/mHome/components/mBannerLink/associate_Constructor/m_active_news'),
      name: "m_active_news",
      meta: {
        title: "Banner二建-h5",
      }
    },
    {
      path: "/m_active_news_yj",
      component: () => import('@/components/h5/mHome/components/mBannerLink/associate_Constructor/m_active_news_yj'),
      name: "m_active_news_yj",
      meta: {
        title: "Banner一建-h5",
      }
    },
    {
      path: "/supervising_Engineer",
      component: () => import('@/components/h5/mHome/components/mBannerLink/supervising_Engineer/supervising_Engineer'),
      name: "supervising_Engineer",
      meta: {
        title: "Banner2023监理工程-h5",
      }
    },
    {
      path: "/registration_Structure",
      component: () => import('@/components/h5/mHome/components/mBannerLink/registration_Structure/registration_Structure'),
      name: "registration_Structure",
      meta: {
        title: "Banner2023注册结构工程师-h5",
      }
    },
    {
      path: "/login",
    //   component: () => import('@/components/login/login'),
      name: "login",
      meta: {
        title: "欢迎登录",
        requireAuth: true
      }
    },
    {
      path: "/register",
      // component: () => import('@/components/register/register'),
      name: "Register",
      meta: {
        title: "欢迎注册",
        requireAuth: true
      }
    },
    {
      path: "/personalSafe",
      // component: () => import('@/components/register/register'),
      name: "personalSafe",
      meta: {
        title: "账号安全",
        requireAuth: true
      }
    },
    {
      path: "/personalHome",
      // component: () => import('@/components/register/register'),
      name: "PersonalHome",
      meta: {
        title: "个人中心",
        requireAuth: true
      }
    },
    {
      path: "/gwc",
      // component: () => import('@/components/register/register'),
      name: "gwc",
      meta: {
        title: "个人中心",
        requireAuth: true
      }
    },
    
  ],
  scrollBehavior (to, from, savedPosition) {
    // return 期望滚动到哪个的位置
    return {x:0,y:0}
  }
});



// WEBPACK FOOTER //
// ./src/router/index.js